export default "__VITE_ASSET__tKd7uolM__"